import React from 'react';
import { Clock, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { useNow } from '../../lib/useCoinData';

export const ageSeconds = (at, now) => (at ? Math.max(0, Math.round((now - new Date(at).getTime()) / 1000)) : null);
export const ageText = (s) => (s === null ? '—' : s < 2 ? 'şimdi' : s < 60 ? `${s} sn önce` : `${Math.floor(s / 60)} dk ${s % 60} sn önce`);

export default function DataFreshness({ at, quality, testid = 'data-freshness' }) {
    const now = useNow(1000);
    const age = ageSeconds(at, now);
    if (age === null) return null;
    const missing = quality?.missing || [];
    const backup = quality?.klines_source === 'binance' || quality?.klines_source === 'okx_stale';
    const tone =
        age > 180 ? 'text-rose-300 border-rose-500/40 bg-rose-500/10'
            : age > 60 || missing.length ? 'text-amber-200 border-amber-500/40 bg-amber-500/10'
                : 'text-emerald-200 border-emerald-500/30 bg-emerald-500/10';
    const Icon = missing.length ? AlertTriangle : age > 60 ? Clock : CheckCircle2;
    return (
        <span
            data-testid={testid}
            title={`Analiz zamanı: ${new Date(at).toLocaleTimeString('tr-TR')}${backup ? ' · mum verisi yedek kaynaktan' : ''}`}
            className={`inline-flex items-center gap-1 text-[10px] font-mono border rounded-sm px-1.5 py-0.5 ${tone}`}
        >
            <Icon className="h-3 w-3" />
            Veri: {ageText(age)} · {missing.length ? `eksik: ${missing.join(', ')}` : 'tam'}
            {quality?.klines_source === 'binance' && ' · mum: Binance yedek'}
        </span>
    );
}
